import { Button, Flex, Spin, Table, type TableProps } from 'antd'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import type { Coupon } from '../../../../types'

dayjs.extend(relativeTime)

export const CouponTable = ({
    coupons,
    onEdit,
    onDelete
}: {
    coupons: Coupon[]
    onEdit: (coupon: Coupon) => void
    onDelete: (id: string) => void
}) => {
    const columns: TableProps<Coupon>['columns'] = [
        {
            title: 'Code',
            dataIndex: 'code'
        },
        {
            title: 'Expiry',
            key: 'expiry',
            render: ({ expiry }) => {
                return <>{dayjs(expiry).format('MMMM D, YYYY HH:mm:ss')}</>
            }
        },
        {
            title: 'Times Used',
            dataIndex: 'timesUsed'
        },
        {
            title: 'Product',
            key: 'product',
            render: (f, record) => {
                return <>{record.product?.name}</>
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Flex gap="middle" align="center">
                    <Button
                        type="link"
                        onClick={async () => {
                            onEdit(record)
                        }}
                    >
                        Edit
                    </Button>
                    <Button
                        type="link"
                        onClick={async () => {
                            onDelete(record.id)
                        }}
                    >
                        Delete
                    </Button>
                </Flex>
            )
        }
    ]

    if (!coupons) return <Spin />

    return (
        <>
            <Flex vertical gap={20}>
                <Table columns={columns} dataSource={coupons || []} rowKey="id" pagination={{ pageSize: 50 }} />
            </Flex>
        </>
    )
}
